// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-group-label {
  padding: 5px 0;
  display: block;
}
.list-block-item {
  padding: 10px 20px;
  list-style-type: none;
  border: 1px solid gray;
  border-radius: 10px;
  margin: 0 0 15px 0;
  background-color: #ffffff;
}
li.list-block-item:last-of-type {
  margin-bottom: 0;
}
.list-blocks {
  padding: 20px;
  margin: 0;
}
.list-blocks.dark {
  background-color: #80808038;
}
.nkl-checkbox-wrapper + .nkl-checkbox-wrapper {
  margin-left: 0px;
}
.nkl-form-item-control-input {
  padding: 0px;
  min-height: 0px;
}
.nkl-form-item {
  margin-bottom: 0px;
}
.nkl-card-body {
  padding: 10px;
}
.nkl-form-item-explain {
  padding-top: 5px;
}
.nkl-checkbox-wrapper {
  padding-top: 5px;
}
.localizable-content {
  padding-left: 10px;
}
.arcade-card-header {
  border-bottom: 1px solid lightgrey;
  padding-left: 10px;
}
/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */
/* stylelint-disable no-duplicate-selectors */
/* stylelint-disable */
/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
